import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        supportedLngs: ['en', 'hi', 'mr'],
        lng: localStorage.getItem('language') || 'en',
        ns: ['common', 'RawMaterialMaster', 'BOPMaster', 'MachineMaster', 'OverheadsProfits', 'OperationMaster', 'FuelPowerMaster', 'PartMaster', 'VendorMaster', "Costing", "Dashboard", "MasterLabels", "CostingLabels","CommonLabels"],
        defaultNS: 'common',
        Backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        },
        debug: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n